import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiClient } from '@/lib/api-client';

export interface BillingSummary {
  status: string;
  currentPeriodEnd: string | null;
  mpPreapprovalId: string | null;
  currency: string;
  planKey: string;
  planName: string;
  planPrice: number;
  includedModules: string[];
  extras: Array<{ key: string; name: string; price: number }>;
  total: number;
}

async function getSummary(): Promise<BillingSummary> {
  const { data } = await apiClient.get<BillingSummary>('/billing/summary');
  return data;
}

export function useBillingSummary() {
  return useQuery({ queryKey: ['billing-summary'], queryFn: getSummary, retry: false });
}

/** Crea la suscripcion en Mercado Pago y redirige al init_point de pago. */
export function useCheckout() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<{ initPoint: string }>('/billing/checkout');
      return data;
    },
    onSuccess: (data) => {
      if (data.initPoint) window.location.href = data.initPoint;
      else toast.error('No se pudo iniciar el pago');
    },
    onError: (error: unknown) => {
      const message =
        (error as { response?: { data?: { message?: string } } }).response?.data?.message ??
        'No se pudo iniciar el pago';
      toast.error(message);
    },
  });
}
